import { BaseService, PaginatedResult } from "./base.service";
import {
  HealthMemoryDto,
  CreateHealthMemoryDto,
  UpdateHealthMemoryDto,
  HealthMemoryResponseDto,
  HealthMemoryQueryParams,
} from "@/types/health-memory";

export class HealthMemoryService extends BaseService {
  private memberId: string;

  constructor(memberId: string) {
    super(`/members/${memberId}/health-memory`);
    this.memberId = memberId;
  }

  async getHealthMemories(filter?: any): Promise<PaginatedResult<HealthMemoryResponseDto>> {
    return await this.post<PaginatedResult<HealthMemoryResponseDto>>('/getAll', filter || {});
  }

  async getHealthMemory(id: string): Promise<HealthMemoryResponseDto> {
    return await this.get<HealthMemoryResponseDto>(`/${id}`);
  }

  async createHealthMemory(memory: CreateHealthMemoryDto): Promise<HealthMemoryResponseDto> {
    return await this.post<HealthMemoryResponseDto>('', memory);
  }

  async updateHealthMemory(id: string, memory: UpdateHealthMemoryDto): Promise<HealthMemoryResponseDto> {
    return await this.put<HealthMemoryResponseDto>(`/${id}`, memory);
  }

  async deleteHealthMemory(id: string): Promise<void> {
    await this.delete(`/${id}`);
  }
}
